<style lang="less" scoped>
  .make_li {
    margin: auto;
    margin-bottom: 20px;
    width: 95%;
    .address {
      margin-bottom: 15px;
      color: #999;
    }
    .contacts {
      color: #666;
    }
  }
  .make-box {
    padding-top: 20px;
  }
  .diy-btn {
    position: absolute;
    right: 20px;
    bottom: 20px;
  }

   .diy-btn2 {
    position: absolute;
    right: 130px;
    bottom: 20px;
  }
  .hader {
    background-color: #000;
    padding: 15px 20px;
    overflow: hidden;
    color: #fff;
    position: relative;
    .tx {
      width: 42px;
      height: 42px;
      float: left;
      display: block;
      border-radius: 50%;
    }
    .user-left {
      margin-left: 50px;
      color: hsla(0, 0%, 100%, .7);
      .user-name {
        font-size: 16px;
        color: #fff;
        font-weight: 700;
      }
    }
  }
  .exit {
    position: absolute;
    right: 15px;
    top: 50%;
    font-size: 14px;
    margin-top: -7px;
  }
</style>

<template>
  <div class="main">
    <Spin size="large" fix v-if="load"></Spin>
    <div class="hader">
      <img :src="user.portrait || 'assets/images/mr.jpeg'" class="tx">
      <div class="user-left">
        <div class="user-name">{{user.full_name}}</div>
        <div class="user-jb">{{user.level}}</div>
      </div>
      <span class="exit" @click="exit">退出登录</span>
    </div>
    <div class="make-box">
      <div class="make_li" v-for="(item,index) in rdata.list" :key="index">
        <Card>
          <h3 slot="title">{{item.enterprise_name}}</h3>
          <span slot="extra">
             上门时间：{{item.make_date}}
          </span>
          <div class="address"> {{item.region}} {{item.detail_info}}</div>
          <div class="contacts"> {{item.user_name}} | {{item.tel_number}}</div>
          <Button class="diy-btn" @click="goProduct(item.enterprise_id)" type="primary">+开始定制</Button>


          <Button class="diy-btn2" v-show="item.state == 0" @click="qiandao(item.id)" type="success">上门签到</Button>

        </Card>
      </div>
    </div>
  </div>
</template>

<script>
  var that;
  import Store from 'store';
  import {
    POST,
    Logout
  } from "../plugins/core";
  export default {
    name: 'home',
    data() {
      return {
        load: true,
        user: {
          "full_name": "",
          "portrait": null,
          "level": ""
        },
        rdata: {
          CurrentPage: 1,
          PageCount: 1,
          list: []
        }
      }
    },
    mounted() {
      that = this;
      that.getMake();
      that.init();
    },
    methods: {
      goProduct(id){
       Store.set('enterprise_id',id);
       that.$router.push({ path: 'product/'+id})
      },
      init(){
        if (Store.get("user")) that.user = Store.get("user");
      },
      exit() {
        that.$Modal.confirm({
          title: '确认退出当前登录账号?',
          onOk: () => {
            Logout();
          }
        });
      },
      qiandao(id){


 that.$Modal.confirm({
          title: '请确认已上门服务?',
          onOk: () => {
              POST('/setMakeState', {id}).then(function(res) {
          that.load = false;
          if (res.state == 200) {
            that.getMake();
          }
        });
          }
        });


  

      },
      getMake() {
        POST('/getAdviserMake', {}).then(function(res) {
          that.load = false;
          if (res.state == 200) {
            that.rdata = res.data;
          }
        });
      }
    }
  }
</script>
